import './Instruction.css';
import { useNavigate } from 'react-router-dom';

export default function Instruction() {
    const navigate = useNavigate();
    return (
        <main className="instruction">
            <div className="instruction__top">
                <span className="instruction__label">
                    Психологический тест
                </span>

                <span className="instruction__number">
                    01 / 07
                </span>
            </div>

            <section className="instruction__content">

                <h1 className="instruction__title">
                    Какой тип
                    <br />
                    <em>отдыха</em> вам
                    <br />
                    необходим?
                </h1>

                <div className="instruction__description">
                    <p>
                        Тест создан на основе книги Сандры Далтон-Смит
                        <i> «Sacred Rest»</i> и модели 7 типов отдыха.
                    </p>

                    <p>
                        Поможет узнать, какого именно отдыха вам сейчас не
                        хватает.
                    </p>
                </div>

                <div className="instruction__stats">

                    <div className="instruction__stat">
                        <strong>7</strong>
                        <span>типов<br />отдыха</span>
                    </div>

                    <div className="instruction__stat">
                        <strong>70</strong>
                        <span>вопросов<br />всего</span>
                    </div>

                    <div className="instruction__stat">
                        <strong>10</strong>
                        <span>минут<br />примерно</span>
                    </div>

                </div>

                <button className="instruction__button" onClick={() => navigate('/test')}>
                    <span>Пройти тест</span>
                    <span>→</span>
                </button>

            </section>

        </main>
    );
}